/**
 * Test IDs for gameless-mode elements.
 */
export const gamelessTestIds = {
  /** Test ID for the full-space video grid container. */
  container: 'gameless-grid',
  /** Test ID for button to minimize self view. */
  minimizeSelfViewButton: 'minimize-self-view-button',
  /** Test ID for button to restore self view to the grid. */
  restoreSelfViewButton: 'restore-self-view-button',
  /** Test ID for the floating self view picture-in-picture container. */
  selfViewPip: 'self-view-pip',
} as const

